import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";

import { Grid, Image, Skeleton } from "antd";

import "swiper/css";
import "swiper/css/effect-fade";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useGetBanner } from "../../hooks/banner.hooks";
import { BannerResponse } from "../../hooks/data";
import "./styles.scss";

const PromotionBanner: React.FC = () => {
  const { useBreakpoint } = Grid;
  const autoplayDelay = 5000; // ms
  const screens = useBreakpoint();

  const { data: banners, isLoading: loadingBanner } = useGetBanner({});
  const [visibleBanner, setVisibleBanner] = useState<BannerResponse[]>([]);

  useEffect(() => {
    if (!banners) return;
    if (screens.xs) {
      setVisibleBanner(banners);
    } else {
      setVisibleBanner([
        ...banners?.slice(-1),
        ...banners,
        ...banners?.slice(0, -1),
      ]);
    }
  }, [banners]);

  useEffect(() => {
    console.debug("vis", visibleBanner);
  }, [visibleBanner]);

  const renderLoading = () => {
    return (
      <div style={{ display: "flex", gap: "16px", justifyContent: "center" }}>
        {[1, 2, 3].map((i) => (
          <Skeleton.Button
            key={i}
            active
            style={{
              width: 616,
              height: 264,
              borderRadius: 12,
            }}
          />
        ))}
      </div>
    );
  };
  const getBannerSize = () => {
    if (screens.xxl) return { width: 616, height: 264 };
    if (screens.xl) return { width: 616, height: 264 };
    if (screens.lg) return { width: 616, height: 264 };
    if (screens.md) return { width: 616, height: 264 };
    if (screens.sm) return { width: 397, height: 170 };
    return { width: 333, height: 143 }; // Default for xs or smaller
  };

  const handleOpenUrl = (url: string | null | undefined) => {
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className={`${styles.bannerContainer} promo-banner`}>
      {!banners || loadingBanner ? (
        renderLoading()
      ) : (
        <Swiper
          pagination={
            screens.xs ? { dynamicBullets: true, clickable: true } : undefined
          }
          modules={[Autoplay, Pagination]}
          slidesPerView={"auto"}
          centeredSlides={true}
          loop={true}
          autoplay={{ delay: autoplayDelay, disableOnInteraction: false }}
          spaceBetween={28}
          slideToClickedSlide={true}
          style={{ padding: 0 }}
        >
          {visibleBanner.map((banner: BannerResponse, index: number) => {
            return (
              <SwiperSlide
                key={`banner_${index}`}
                style={{ ...getBannerSize() }}
              >
                <Image
                  onClick={() => handleOpenUrl(banner?.link_url)}
                  width={"100%"}
                  height={"100%"}
                  preview={false}
                  src={banner.image_url}
                  className={styles.bannerImage}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      )}
    </div>
  );
};

export default PromotionBanner;
